import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">
        © 2025 Accenture. All Rights Reserved. Accenture Confidential. For internal use only.
        Powered by Learning Experiences - L&TT, ATCI.
      </p>
    </footer>
  );
}

export default Footer;
